import SweetScroll from 'sweet-scroll';

/**
 * SweetScroll
 * @doc https://www.npmjs.com/package/sweet-scroll#3-initialize-sweetscroll
 */
export default class SmoothScroll {
  constructor () {
    this.indexLink = document.querySelector('.o-index-link');
    this.offset = (!this.indexLink) ? 0 : -96; // unit-9 + unit-3
    this.instance = new SweetScroll({
      trigger: 'a[href^="#"]',
      duration: 800,
      easing: 'easeOutQuint',
      updateURL: true,
      offset: this.offset,
      before: (_to, _$trigger, scroller) => {
        // アニメーション中ならキャンセル
        if (scroller.isAnimating) {
          scroller.stop(true);
        }
      }
    });
  }

  get scroller () {
    return this.instance;
  }
}
